/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thermal_Shock_SetpointInputs */



/**
* | output |
* | --- |
* | "Thermal shock setpoint" |
*
* @param {Thermal_Shock_SetpointInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const thermal_shock_setpoint = /** @type {((inputs?: Thermal_Shock_SetpointInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thermal_Shock_SetpointInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Thermal shock setpoint")
	return /** @type {LocalizedString} */ ("Consigne de choc thermique")
});